import { TransportVisualizationAdministrationModule } from './transport-visualization-administration/transport-visualization-administration.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportVisualizationAdministrationWidgetComponent } from './transport-visualization-administration/transport-visualization-administration-widget/transport-visualization-administration-widget.component';
import { WidgetDefinition, WidgetRegistryService } from '@sdbn/common';
import { TransportConditionsModule } from './transport-conditions/transport-conditions.module';
import { StationConditionsModule } from './station-conditions/station-conditions.module';
import { VehicleArchiveAdministrationModule } from './vehicle-archive-administration/vehicle-archive-administration.module';
import { VehicleArchiveAdministrationWidgetComponent } from './vehicle-archive-administration/vehicle-archive-administration-widget/vehicle-archive-administration-widget.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TransportVisualizationAdministrationModule,
    TransportConditionsModule,
    StationConditionsModule,
    VehicleArchiveAdministrationModule
  ]
})
export class ControlModule {

  widgetDefinitions = [
    { key: 'transportVisualizationAdministration', name: 'Transport Visualization', description: null, icon: 'fa-light fa-painter-roller', groupIdentifier: 'yard-control', widgetComponent: TransportVisualizationAdministrationWidgetComponent, editorComponent: null, autoreload: true },
    { key: 'vehicleArchiveAdministration', name: 'Vehicle Archive', description: null, icon: 'fa-light fa-ballot-check', groupIdentifier: 'yard-control', widgetComponent: VehicleArchiveAdministrationWidgetComponent, editorComponent: null, autoreload: true }
  ];

  constructor(
    widgetRegistryService: WidgetRegistryService,
  ) {

    for (const definition of this.widgetDefinitions) {
      if (definition != null) {
        widgetRegistryService.registerWidget(new WidgetDefinition(definition));
      }
    }

  }

}
